
import Vue from 'vue';
import type { PropType } from 'vue';
import MAP from '@/store/modules/MapModule';
import MISC_DATA from '@/store/modules/MiscDataModule';
import { ITruckGroupBySize, Truck, ITruckFilterSettings } from '@/types/truck';

export default Vue.extend({
	name: 'SelectTruckSize',

	props: {
		trucks: {
			type: Object as PropType<ITruckGroupBySize>,
			default: null
		},

		value: {
			type: Array as () => string[],
			default: () => []
		},

		truckList: {
			type: Array as PropType<Truck[]>,
			default: null
		},

		fromSlotPicker: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			selectedTruckSize: '',
			selectedSizes: [...this.value]
		};
	},

	computed: {
		MISC_DATA: () => MISC_DATA,
		MAP: () => MAP,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},

		sizeCards(): any {
			if (this.trucks && this.fromSlotPicker) {
				const size_cards = [
					{
						label: 'L',
						color: 'cyan123',
						truck_amount: this.trucks.l ? this.trucks.l.length : 0,
						truck_price: this.MISC_DATA.truck_min_price.L.price_24,
						truck_price_6hours: this.MISC_DATA.truck_min_price.L.price_6
					},
					{
						label: 'XL',
						color: 'orange123',
						truck_amount: this.trucks.xl ? this.trucks.xl.length : 0,
						truck_price: this.MISC_DATA.truck_min_price.XL.price_24,
						truck_price_6hours: this.MISC_DATA.truck_min_price.XL.price_6
					},
					{
						label: 'XXL',
						color: 'pink123',
						truck_amount: this.trucks.xxl ? this.trucks.xxl.length : 0,
						truck_price: this.MISC_DATA.truck_min_price.XXL.price_24,
						truck_price_6hours: this.MISC_DATA.truck_min_price.XXL.price_6
					}
				];
				return size_cards.filter((c: any) => c.truck_amount > 0);
			}

			return [{ label: 'L' }, { label: 'XL' }, { label: 'XXL' }];
		}
	},

	watch: {
		value(newValue) {
			if (!this.fromSlotPicker) {
				this.selectedSizes = [...newValue];
			}
		}
	},

	mounted() {
		if (this.truckList && this.fromSlotPicker) {
			if (this.truckList[0]) {
				this.selectedTruckSize = this.truckList[0].size_group.toLowerCase();
			}
		}
	},

	methods: {
		selectSize(size: string) {
			if (this.fromSlotPicker) {
				this.selectedTruckSize = size.toLowerCase();
				this.$emit('updateTruckSize', size);
				return;
			}

			const index = this.selectedSizes.indexOf(size);
			if (index === -1) {
				this.selectedSizes.push(size);
			} else {
				this.selectedSizes.splice(index, 1);
			}

			this.$emit('input', this.selectedSizes);
			MAP.updateCurrentFilter({
				...MAP.current_filter,
				sizes: this.selectedSizes
			} as ITruckFilterSettings);
			this.$emit('fetch-trucks');
		}
	}
});
